import ChatsService from './ChatController';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { addInteraction, addMessage, closeConversation, selectInteraction, updateTracking } from '../redux/interactionsSlice';
import ToastrCustom from '../components/utils/toastrcustom';
import { useNavigate } from "react-router-dom";
import { notify, notifyWithAction } from 'src/components/utils/utils';

//* This dispacher is used to update react redux slices without any view being redered
class ChatEventDispacherService extends Component {

    constructor(props) {
        super(props)
        this.toastrRef = React.createRef();
    }

    async componentDidMount(nextProps, nextState) {

        if (!ChatsService.connected)
            await ChatsService.connect();

        if (!("Notification" in window)) {
            console.log("Browser does not support desktop notification");
        } else {
            Notification.requestPermission();
        }

        ChatsService.registerInitConversation(this.props.addInteraction);

        ChatsService.registerAddMessage(message => {
            let current = this.props.interactions.find(x => x.id === message.id);
            if (current && !current.closed) {
                if (this.toastrRef && this.toastrRef.current) {
                    this.toastrRef.current.setType("error");
                    this.toastrRef.current.setMessage(message);
                    this.toastrRef.current.show();
                }

                this.props.addMessage(message);
                notify("Fidelity Agent", message.text, `${window.location.origin}${window.location.pathname}/img/${message.channel}.png`, "chat");
            }

        });

        ChatsService.registerCloseConversation(this.props.closeConversation);
        ChatsService.registerTransferChat(this.props.closeConversation);
        ChatsService.registerUpdateLocation(this.props.updateTracking);
    }
    select = (e) => {

        e.preventDefault();

        let user = JSON.parse(localStorage.getItem("fc-logged"));
        let id = this.toastrRef.current.getId();
        this.props.selectInteraction(id);
        ChatsService.sendSeen(id, user.userId);
        this.toastrRef.current.hide();
        this.props.navigate("interactions/chat");
    }

    render() {
        return (
            <>
                <ToastrCustom ref={this.toastrRef} select={this.select} />
            </>)
    };
}

function WithNavigate(props) {
    let navigate = useNavigate();
    return <ChatEventDispacherService {...props} navigate={navigate} />
}
const mapStateToProps = (state) => {
    return {
        interactions: state.interaction.interactions
    };
};
export default connect(mapStateToProps, { addInteraction, addMessage, closeConversation, selectInteraction, updateTracking })(WithNavigate);